import _extends from "@babel/runtime/helpers/extends";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import { translate } from '@haldor/ui';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import { withRouter } from 'react-router-dom';
import Moment from "moment";
import { getRootUrl } from 'helpers/url';
import { isUserTeacher } from 'helpers/user';
import { updatePlan, createPlan, getPlanDetails } from 'actions/plans';
import { getSection } from "actions/sections";
import { saveBlocksOnReference, updateBlocksOnReference, deleteBlock } from 'actions/blocks';
import BlockEditor from 'components/BlockEditor';
import TeacherAdjustments from "containers/AdditionalAdjustments/Display/TeacherAdjustments";
import DatePickerFromTo from '../Partials/DatePickerFromTo';
import GroupSelector from '../Partials/GroupSelector';
import SearchPreschoolGoals from '../SearchPreschoolGoals';
import { Editor } from 'UI/Inputs';
import { Checkbox, Button } from '@haldor/ui';
import { Expandable, Spinner } from "UI";

var PreschoolPlanningForm = /*#__PURE__*/function (_Component) {
  _inherits(PreschoolPlanningForm, _Component);

  var _super = _createSuper(PreschoolPlanningForm);

  function PreschoolPlanningForm(props) {
    var _this;

    _classCallCheck(this, PreschoolPlanningForm);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      if (_this.props.cloneView) {
        _this.props.getPlanDetails(_this.props.plan.id).then(function () {
          _this.setState({
            loading: false
          });
        });
      } else {
        _this.setState({
          loading: false
        });
      }

      var sectionId = null;

      if (_this.props.initialValues != null) {
        sectionId = _this.props.initialValues.sectionId;
      }

      if (_this.props.sectionId != null) {
        sectionId = _this.props.sectionId;
      }

      if (sectionId != null) {
        var find = _this.props.sections.find(function (t) {
          return t.id == sectionId;
        });

        if (find == null) {
          _this.setState({
            sectionId: 0
          });
        } else {
          _this.setState({
            sectionId: sectionId
          });

          _this.props.getSection(sectionId).then(function () {
            if (!_this.props.editView) {
              _this.setState({
                students: _this.props.section.students
              });
            }
          });
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "required", function (value) {
      if (typeof value !== 'undefined' && value !== '') {
        if (value.length > 199) {
          // Field failed validation, return error for this field (String)
          return _this.props.translate('field-max-200-chars');
        } // Field passes validation, return a undefined error for this field
        // Rule: Not undefined and not an empty string and not over 200 characters


        return undefined;
      } // Field failed validation, return error for this field (String)


      return _this.props.translate('field-needs-input');
    });

    _defineProperty(_assertThisInitialized(_this), "submit", function (values) {
      return new Promise(function (resolve) {
        var _this$state = _this.state,
            selectedGoals = _this$state.selectedGoals,
            dateStart = _this$state.dateStart,
            dateEnd = _this$state.dateEnd,
            sectionId = _this$state.sectionId;
        var initialValues = _this.props.initialValues;
        var progress = values.progress,
            evaluation = values.evaluation;
        var attachedFiles = [];
        var blocks = [];
        var deletedBlocks = [];

        if (values.blocks != null) {
          blocks = _toConsumableArray(values.blocks);
          blocks.forEach(function (block) {
            if (block.type == 'Haldor.Blocks.Assignment') {
              if (block.resources != null) {
                var resources = [];
                block.resources.forEach(function (resource) {
                  resources.push({
                    id: resource.id,
                    '@odata.type': resource['@odata.type']
                  });
                });
                block.resources = resources;
              }
            }

            return block;
          });

          if (initialValues != null && initialValues.blocks != null) {
            deletedBlocks = _toConsumableArray(initialValues.blocks).filter(function (block) {
              return !blocks.find(function (_bl) {
                return _bl.id == block.id;
              });
            });
          }
        }

        delete values.blocks;
        delete values.progress;
        delete values.evaluation;

        if (values.files == null) {
          values.fields = [];
        }

        var foundProgress = values.fields.find(function (field) {
          return field.title == 'heres-how-we-work';
        });
        var foundEvaluation = values.fields.find(function (field) {
          return field.title == 'evaluation-and-analysis';
        });

        if (foundProgress != null) {
          foundProgress.content = progress;
        } else {
          var progressField = {
            title: 'heres-how-we-work',
            content: progress,
            type: 'MULTILINETEXT',
            roles: [{
              'roleID': 'Teacher'
            }]
          };
          values.fields.push(progressField);
        }

        if (foundEvaluation != null) {
          foundEvaluation.content = evaluation;
        } else {
          var evaluationField = {
            title: 'evaluation-and-analysis',
            content: evaluation,
            type: 'MULTILINETEXT',
            roles: [{
              'roleID': 'Teacher'
            }]
          };
          values.fields.push(evaluationField);
        }
        /* Add custom inputs to the values object that redux form creates */


        values.associatedGoals = selectedGoals;
        values.timeStart = dateStart;
        values.timeEnd = dateEnd;
        values.students = _this.state.students;

        if (values.status == null) {
          values.status = 'PLANNING_OPEN';
        }

        values.sectionId = sectionId;
        values.associatedMatrices = [];
        values.matrix = null;

        if (_this.state.attachedFiles != null && _this.state.attachedFiles.length > 0) {
          attachedFiles = _this.state.attachedFiles;
        }

        values.attachedFiles = attachedFiles;

        if (_this.state.newDocuments != null && _this.state.newDocuments.length > 0) {
          values.attachedFiles = [].concat(_toConsumableArray(values.attachedFiles), _toConsumableArray(_this.state.newDocuments));
        }
        /* Make request */


        var that = _assertThisInitialized(_this);

        if (_this.props.editView) {
          var promises = [];
          promises.push(new Promise(function (resolve) {
            _this.props.updatePlan(values).then(function () {
              resolve(1);
            });
          }));

          if (blocks != null && blocks.length > 0) {
            promises.push(new Promise(function (resolve) {
              _this.props.updateBlocksOnReference(blocks, initialValues.id, 'PLAN').then(function () {
                resolve(1);
              });
            }));
          }

          if (deletedBlocks.length > 0) {
            deletedBlocks.forEach(function (block) {
              promises.push(new Promise(function (resolve) {
                _this.props.deleteBlock(block.id).then(function () {
                  resolve(1);
                });
              }));
            });
          }

          Promise.all(promises).then(function () {
            that.props.onAbort(true, true);
            resolve(1);
          });
        } else {
          if (_this.props.cloneView) {
            if (values.attachedFiles != null) {
              values.attachedFiles.forEach(function (element) {
                element.originId = _this.props.initialValues.id;
              });
            }

            if (blocks != null) {
              blocks.forEach(function (block) {
                block.id = 0;
                return block;
              });
            }
          }

          _this.props.createPlan(values).then(function () {
            var promises = [];

            if (blocks != null && blocks.length > 0) {
              promises.push(_this.props.saveBlocksOnReference(blocks, _this.props.createdPlanId.id, 'PLAN'));
            }

            Promise.all(promises).then(function () {
              if (_this.props.cloneView) {
                window.location = _this.props.createdPlanId.hasOwnProperty('id') ? "".concat(getRootUrl(), "plan/").concat(_this.props.createdPlanId.id) : "".concat(getRootUrl(), "plan/").concat(_this.props.createdPlanId);
              } else {
                _this.props.history.push(_this.props.createdPlanId.hasOwnProperty('id') ? "".concat(getRootUrl(), "plan/").concat(_this.props.createdPlanId.id) : "".concat(getRootUrl(), "plan/").concat(_this.props.createdPlanId));
              }

              resolve(1);
            });
          });
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onGroupChange", function (groupId) {
      if (groupId != 0) {
        var _this$props$section;

        _this.setState({
          sectionId: groupId
        });

        if (((_this$props$section = _this.props.section) === null || _this$props$section === void 0 ? void 0 : _this$props$section.id) != groupId) {
          _this.props.getSection(groupId).then(function () {
            _this.setState({
              students: _this.props.section.students
            });
          });
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onGoalsChange", function (selectedGoals) {
      _this.setState({
        selectedGoals: selectedGoals
      });
    });

    _defineProperty(_assertThisInitialized(_this), "selectDocument", function (files) {
      _this.setState({
        newDocuments: files
      });
    });

    _defineProperty(_assertThisInitialized(_this), "removeInstruction", function (instruction, remove) {
      var attachedFiles = _this.state.attachedFiles;
      var removeFile = attachedFiles.find(function (file) {
        return file.value == instruction;
      });
      removeFile.markedForDeletion = remove;

      _this.setState({
        attachedFiles: attachedFiles
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onDateChange", function (dates) {
      _this.setState({
        dateStart: dates.start,
        dateEnd: dates.end
      });
    });

    _defineProperty(_assertThisInitialized(_this), "getSectionStudents", function () {
      var sectionStudents = _this.props.section.students;

      var missingStudents = _this.state.students.filter(function (t) {
        return sectionStudents.find(function (s) {
          return s.id == t.id;
        }) == null;
      });

      missingStudents.forEach(function (student) {
        student.firstName = student.firstname;
        student.lastName = student.lastname;
        student.missing = true;
      });
      sectionStudents = sectionStudents.concat(missingStudents);
      return sectionStudents;
    });

    _defineProperty(_assertThisInitialized(_this), "onStudentSelect", function (student) {
      var foundStudent = false;

      _this.state.students.find(function (studentPlan) {
        if (studentPlan.id == student.id) {
          foundStudent = true;
        }
      });

      var students = _this.state.students;

      if (foundStudent) {
        if (student.missing && !student.remove) {
          student.remove = true;
        } else if (student.missing && student.remove) {
          student.remove = false;
        } else {
          students = students.filter(function (t) {
            return t.id != student.id;
          });
        }
      } else {
        students.push(student);
      }

      _this.setState({
        students: students
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderInput", function (_ref) {
      var input = _ref.input,
          label = _ref.label,
          type = _ref.type,
          placeholder = _ref.placeholder,
          _ref$meta = _ref.meta,
          touched = _ref$meta.touched,
          error = _ref$meta.error,
          warning = _ref$meta.warning;
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("input", _extends({}, input, {
        placeholder: placeholder || label,
        type: type,
        style: touched && error ? {
          border: '1px solid red'
        } : {}
      })), touched && (error && /*#__PURE__*/React.createElement("span", {
        style: {
          marginTop: '1rem',
          color: 'red'
        }
      }, error) || warning && /*#__PURE__*/React.createElement("span", {
        style: {
          marginTop: '1rem',
          color: 'red'
        }
      }, warning)));
    });

    _defineProperty(_assertThisInitialized(_this), "renderStudents", function () {
      var section = _this.props.section;
      var sectionId = _this.state.sectionId;

      if (section != null && sectionId != "0" && sectionId != null) {
        var sectionStudents = _this.getSectionStudents();

        return sectionStudents.map(function (student) {
          var checked = false;
          var disabled = false;

          _this.state.students.forEach(function (studentPlan) {
            if (studentPlan.id == student.id) {
              checked = true;

              if (studentPlan.remove) {
                checked = false;
              }

              if (_this.props.assessments != null && _this.props.editView) {
                _this.props.assessments.find(function (assessment) {
                  if (assessment.studentId == student.id) {
                    disabled = true;
                  }
                });
              }
            }
          });

          var title = student.firstName + " " + student.lastName;

          if (disabled && _this.props.editView) {
            title += " (" + _this.props.translate("assessed") + ")";
          }

          if (student.missing) {
            title += " (" + _this.props.translate("removed-from-group") + ")";
          }

          return /*#__PURE__*/React.createElement("div", {
            style: {
              marginBottom: "1rem"
            },
            key: student.id
          }, /*#__PURE__*/React.createElement(Checkbox, {
            name: "studentSelect",
            value: checked,
            disabled: disabled,
            onChange: function onChange() {
              _this.onStudentSelect(student);
            },
            label: title
          }));
        });
      } else {
        return /*#__PURE__*/React.createElement("div", null, _this.props.translate("select-a-group-to-continue"));
      }
    });

    var _students = [];

    if (_this.props.editView) {
      if (props.initialValues != null) {
        _students = props.initialValues.students;
      }
    }

    _this.state = {
      selectedGoals: [],
      attachedFiles: props.editView || props.cloneView ? props.initialValues.attachedFiles : [],
      dateStart: null,
      dateEnd: null,
      sectionId: '0',
      newDocuments: [],
      students: _students,
      loading: true
    };
    return _this;
  }

  _createClass(PreschoolPlanningForm, [{
    key: "render",
    value:
    /* Begin render */
    function render() {
      var _this2 = this;

      var _this$props = this.props,
          handleSubmit = _this$props.handleSubmit,
          submitting = _this$props.submitting,
          valid = _this$props.valid,
          initialValues = _this$props.initialValues;
      var sectionId = this.state.sectionId;

      if (this.state.loading) {
        return /*#__PURE__*/React.createElement(Spinner, {
          center: true
        });
      }

      return /*#__PURE__*/React.createElement("div", {
        className: "form-container form-create_task"
      }, submitting ? /*#__PURE__*/React.createElement("div", {
        className: "is_sending"
      }, /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("span", {
        className: "loading-spinner"
      }))) : null, /*#__PURE__*/React.createElement("form", {
        onSubmit: handleSubmit(this.submit),
        className: "form form-component"
      }, !this.props.editView ? /*#__PURE__*/React.createElement("div", {
        className: "form-row"
      }, /*#__PURE__*/React.createElement(GroupSelector, {
        disabled: this.props.sectionId && this.props.cloneView == false ? true : false,
        onChange: this.onGroupChange,
        required: true,
        sectionId: this.state.sectionId
      })) : null, /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: "0.5rem"
        }
      }, /*#__PURE__*/React.createElement(Expandable, {
        title: this.props.translate("students")
      }, this.renderStudents())), /*#__PURE__*/React.createElement("div", {
        className: "form-row"
      }, /*#__PURE__*/React.createElement(DatePickerFromTo, {
        type: "plan",
        onChange: this.onDateChange,
        values: initialValues,
        cloneView: this.props.cloneView
      })), /*#__PURE__*/React.createElement("div", {
        className: "form-row input"
      }, /*#__PURE__*/React.createElement("label", null, this.props.translate('title'), "*"), /*#__PURE__*/React.createElement(Field, {
        component: this.renderInput,
        type: "text",
        name: "title",
        placeholder: "Titel",
        validate: this.required
      })), /*#__PURE__*/React.createElement("div", {
        className: "form-row"
      }, /*#__PURE__*/React.createElement("label", null, this.props.translate('select-goals')), /*#__PURE__*/React.createElement(SearchPreschoolGoals, {
        selectedGoals: initialValues.associatedGoals,
        onChange: this.onGoalsChange
      })), isUserTeacher(this.props.currentUser) ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        className: "form-row"
      }, /*#__PURE__*/React.createElement(Field, {
        component: Editor,
        name: "evaluation",
        label: "Utv\xE4rdering och analys",
        placeholder: "Utv\xE4rdering och analys",
        translate: this.props.translate
      })), /*#__PURE__*/React.createElement("div", {
        className: "form-row"
      }, /*#__PURE__*/React.createElement(Field, {
        component: Editor,
        name: "progress",
        label: "S\xE5 h\xE4r jobbar vi vidare",
        placeholder: "S\xE5 h\xE4r jobbar vi vidare",
        translate: this.props.translate
      }))) : null, /*#__PURE__*/React.createElement("div", {
        className: "form-divider"
      }), this.props.services.additionalAdjustments ? /*#__PURE__*/React.createElement(Expandable, {
        title: this.props.translate("additional-adjustments")
      }, /*#__PURE__*/React.createElement(TeacherAdjustments, {
        disableCommenting: true,
        groupId: sectionId != '0' ? sectionId : null
      })) : null, /*#__PURE__*/React.createElement(Field, {
        component: BlockEditor,
        name: "blocks"
      }), /*#__PURE__*/React.createElement("div", {
        className: "form-divider"
      }), /*#__PURE__*/React.createElement("div", {
        className: "form-row spacing submit"
      }, /*#__PURE__*/React.createElement(Button, {
        onClick: handleSubmit(function (values) {
          return _this2.submit(_objectSpread(_objectSpread({}, values), {}, {
            status: 'PLANNING_OPEN'
          }));
        }),
        disabled: submitting || !valid || sectionId == '0'
      }, this.props.editView ? this.props.translate('save') : this.props.translate('publish')), this.props.editView && initialValues.status != "PLANNING_DRAFT" ? null : /*#__PURE__*/React.createElement(Button, {
        onClick: handleSubmit(function (values) {
          return _this2.submit(_objectSpread(_objectSpread({}, values), {}, {
            status: 'PLANNING_DRAFT'
          }));
        }),
        type: "secondary",
        disabled: submitting || !valid || sectionId == '0'
      }, this.props.translate('save-draft')), /*#__PURE__*/React.createElement("div", {
        className: "align-right"
      }, /*#__PURE__*/React.createElement(Button, {
        type: "secondary",
        onClick: function onClick(e) {
          e.preventDefault();

          _this2.props.onAbort();
        }
      }, this.props.translate('Cancel'))))));
    }
  }]);

  return PreschoolPlanningForm;
}(Component);

function mapStateToProps(state) {
  var initialValues = _objectSpread({}, state.planning.active_plan);

  initialValues.progress = '';
  initialValues.evaluation = '';

  if (initialValues != null && initialValues.fields != null) {
    var foundProgress = initialValues.fields.find(function (field) {
      return field.title == 'heres-how-we-work';
    });
    var foundEvaluation = initialValues.fields.find(function (field) {
      return field.title == 'evaluation-and-analysis';
    });

    if (foundProgress != null) {
      initialValues.progress = foundProgress.content;
    }

    if (foundEvaluation != null) {
      initialValues.evaluation = foundEvaluation.content;
    }
  }

  if (state.Blocks.reference != null) {
    initialValues.blocks = state.Blocks.reference;
  }

  return {
    initialValues: initialValues,
    translate: translate(state.Languages.translations),
    sections: state.sections.educationGroups,
    section: state.sections.activeSection,
    currentUser: state.user.currentUser,
    services: state.Services.availableServices,
    createdPlanId: state.planning.createdPlanId
  };
}

export default withRouter(connect(mapStateToProps, {
  createPlan: createPlan,
  updatePlan: updatePlan,
  getSection: getSection,
  saveBlocksOnReference: saveBlocksOnReference,
  updateBlocksOnReference: updateBlocksOnReference,
  deleteBlock: deleteBlock,
  getPlanDetails: getPlanDetails
})(reduxForm({
  form: 'PreschoolPlanningForm',
  destroyOnUnmount: true
})(PreschoolPlanningForm)));